// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__NcalayerClientWrapper from "../util/bindings/NcalayerClientWrapper.js";
import * as Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_module from "../../../../proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.js";
import * as Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign from "../../../../proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_sign.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__Let_syntax from "../../../../packages/core/lib/Let_syntax.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Reader from "../../../../vendored/ocaml_protoc_plugin/reader.js";
import * as Ocaml_protoc_plugin__Writer from "../../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const command = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_module.Buhta.Cert.Ncamodule.Rpc.V1alpha1.NcaModuleCommand.to_int;

function args(args$1) {
  return args$1;
}

const Ncamodule = {
  command: command,
  args: args
};

const SignCert = {};

const make = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.Signable.make;

const metadata = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.Signable.Metadata.make;

const xml = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.Signable.XmlDocument.make;

const file = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.Signable.FileDocument.make;

const Signable = {
  make: make,
  metadata: metadata,
  xml: xml,
  file: file
};

const SignedDocument = {};

const makeRequest = Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.SelectSignCertArgs.make;

function serialize(request) {
  return Buhta_core__Grpc.binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.SelectSignCertArgs.to_proto, request)));
}

function deserialize(body) {
  return Curry._1(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.SelectSignCertResult.from_proto_exn, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(Buhta_core__Grpc.UInt8Array.fromBase64(body))));
}

const RpcSelectSignCert = {
  makeRequest: makeRequest,
  serialize: serialize,
  deserialize: deserialize
};

function makeRequest$1(cert, $$document, include_x509Opt, param) {
  const include_x509 = include_x509Opt !== undefined ? include_x509Opt : false;
  return Curry._4(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.SignDocumentArgs.make, {
              NAME: "Sign_cert",
              VAL: cert
            }, $$document, include_x509, undefined);
}

const RpcSignDocument = {
  makeRequest: makeRequest$1
};

function makeInitialRequest(tin, documents, include_x509Opt, param) {
  const include_x509 = include_x509Opt !== undefined ? include_x509Opt : false;
  return Curry._4(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.BulkSignDocumentArgs.make, Belt__Belt_Option.mapWithDefault(tin, "not_set", (function (tin) {
                    return {
                            NAME: "Sign_cert_args",
                            VAL: {
                              tin: tin
                            }
                          };
                  })), documents, include_x509, undefined);
}

function makeRequest$2(cert, documents, include_x509Opt, param) {
  const include_x509 = include_x509Opt !== undefined ? include_x509Opt : false;
  return Curry._4(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.BulkSignDocumentArgs.make, Belt__Belt_Option.mapWithDefault(cert, "not_set", (function (crt) {
                    return {
                            NAME: "Sign_cert",
                            VAL: crt
                          };
                  })), documents, include_x509, undefined);
}

function serialize$1(request) {
  return Buhta_core__Grpc.binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.BulkSignDocumentArgs.to_proto, request)));
}

function deserialize$1(body) {
  return Curry._1(Buhta_certapis__Buhta_cert_ncamodule_rpc_v1alpha1_sign.Buhta.Cert.Ncamodule.Rpc.V1alpha1.BulkSignDocumentResult.from_proto_exn, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(Buhta_core__Grpc.UInt8Array.fromBase64(body))));
}

const RpcBulkSignDocument = {
  makeInitialRequest: makeInitialRequest,
  makeRequest: makeRequest$2,
  serialize: serialize$1,
  deserialize: deserialize$1
};

function selectCert(client, request) {
  const args = {
    version: "v1alpha1",
    handler: Curry._1(command, /* NCA_MODULE_COMMAND_SELECT_SIGN_CERT */1),
    payload: serialize(request),
    format: 1
  };
  const payload = {
    module: "com.buhta.cert.ncamodule",
    method: "call",
    args: args
  };
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__NcalayerClientWrapper.send(client, payload), (function (response) {
                if (response.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: deserialize(response._0.body)
                        };
                }
                const match = response._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          code: match.code,
                          message: Belt__Belt_Option.getWithDefault(match.message, "Unexpected error")
                        }
                      };
              }));
}

function bulkSign(client, request) {
  const args = {
    version: "v1alpha1",
    handler: Curry._1(command, /* NCA_MODULE_COMMAND_BULK_SIGN_DOCUMENT */3),
    payload: serialize$1(request),
    format: 1
  };
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__NcalayerClientWrapper.sendWithArgs(client, args), (function (response) {
                if (response.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: deserialize$1(response._0.body)
                        };
                }
                const match = response._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          code: match.code,
                          message: Belt__Belt_Option.getWithDefault(match.message, "Unexpected error")
                        }
                      };
              }));
}

const NcamoduleClient = {
  selectCert: selectCert,
  bulkSign: bulkSign
};

export {
  SignCert ,
  Signable ,
  SignedDocument ,
  Ncamodule ,
  RpcSelectSignCert ,
  RpcSignDocument ,
  RpcBulkSignDocument ,
  NcamoduleClient ,
}
/* Buhta_cabinet__NcalayerClientWrapper Not a pure module */
